/**
 * 7 类人群身份常量（ARCH §7 / PRD A4）
 * code 与 agent_categories.code、users.identity_type 对齐
 */
/** 7 类人群（T1~T7） */
export const IDENTITIES = [
    {
        code: 'T1',
        name: '个人 OPC',
        description: '独立撰稿人、博主、知识付费个体，靠内容吃饭',
        icon: '✍️',
        examples: ['爆款文章', '标题', '大纲', '故事'],
        needs: ['选题', '成稿', '润色', '多平台分发'],
    },
    {
        code: 'T2',
        name: '自媒体创作者',
        description: '抖音/B站/小红书/公众号运营者，追求流量',
        icon: '🎬',
        examples: ['短视频脚本', '小红书笔记', '热点选题'],
        needs: ['脚本', '热点', '涨粉', '变现'],
    },
    {
        code: 'T3',
        name: '企业高管',
        description: 'CEO/VP/总监，时间少、决策重',
        icon: '🏛️',
        examples: ['战略顾问', '演讲撰稿', '行业分析'],
        needs: ['战略', '演讲', '汇报', '行业洞察'],
    },
    {
        code: 'T4',
        name: '企业主',
        description: '中小企业老板，身兼多职',
        icon: '🏢',
        examples: ['BP 撰写', '合同审查', '招聘 JD'],
        needs: ['商业计划', '财务', '法务', '人事'],
    },
    {
        code: 'T5',
        name: '销售',
        description: '一线销售 / 销售经理',
        icon: '🤝',
        examples: ['开发信', '话术打磨', '异议处理'],
        needs: ['获客', '话术', '跟单', '谈判'],
    },
    {
        code: 'T6',
        name: '电商视觉设计',
        description: '电商运营/美工/直播团队',
        icon: '🎨',
        examples: ['详情页设计', '海报设计', '主图/头像生成'],
        needs: ['详情页视觉设计', '海报', '主图', '头像'],
    },
    {
        code: 'T7',
        name: '客服',
        description: '客服主管 / 一线客服',
        icon: '💬',
        examples: ['FAQ 问答', '投诉安抚', '工单分类'],
        needs: ['回复效率', '满意度', '售后'],
    },
];
/** code -> 人群信息 索引 */
export const IDENTITY_MAP = Object.fromEntries(IDENTITIES.map((i) => [i.code, i]));
/** 分类编码列表 */
export const CATEGORY_CODES = ['T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
